import { URI } from '@/config/config';
import axios from 'axios';

export default async ({ rootState }, licencePlate) => {
  try {
    const response = await axios.get(`${URI}vehicle/list-licence-plate`, {
      params: {
        licencePlate,
      },
      headers: {
        'user-token': rootState['DATA-ACCESS'].userToken,
      },
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
